export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
              <i className="ri-information-line text-accent-500 text-sm"></i>
              <span className="text-accent-400 text-xs font-medium">关于我们</span>
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">6080新视觉影院</h2>
          </div>

          <div className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-foreground-800 font-heading font-bold text-base mb-3">平台简介</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  6080新视觉影院成立于2018年，是专注于电视剧全集免费在线观看的专业平台。我们收录超过20000部海内外电视剧资源，涵盖国产剧、港台剧、韩剧、美剧、日剧、泰剧等多元品类，每日同步更新最新首播剧集，致力于为剧迷提供高清不卡顿、流畅秒开的极致追剧体验。
                </p>
                <p className="text-foreground-500 text-sm leading-relaxed mt-3">
                  平台采用多线CDN智能加速与H.265高效编码技术，确保不同网络环境下均能实现快速加载、稳定播放。所有内容无需注册登录即可免费观看，真正实现打开即看、看遍全集的便捷服务。
                </p>
              </div>
              <div>
                <h3 className="text-foreground-800 font-heading font-bold text-base mb-3">核心优势</h3>
                <ul className="space-y-3">
                  {[
                    { icon: 'ri-check-double-line', text: '剧集资源丰富：20000+部覆盖全品类' },
                    { icon: 'ri-check-double-line', text: '高清画质保障：1080P超清秒开不卡顿' },
                    { icon: 'ri-check-double-line', text: '免费无需注册：打开即看无任何付费墙' },
                    { icon: 'ri-check-double-line', text: '每日同步更新：首播剧集第一时间上线' },
                    { icon: 'ri-check-double-line', text: '多设备兼容：电脑手机平板全平台适配' },
                    { icon: 'ri-check-double-line', text: '智能推荐算法：根据观剧偏好精准推送' },
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/15 flex-shrink-0 mt-0.5">
                        <i className={`${item.icon} text-primary-500 text-xs`}></i>
                      </span>
                      <span className="text-foreground-600 text-sm">{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}